/**
 * 首頁頁面中遊戲介紹的圖片title動態調整高度
 */
function cm_title_container_dynamic_height() {

    if (isChrome()) {
        const titleContainerElementArray = document.querySelectorAll(".cm-game-title-container");

        const SVG_WIDTH = 600;
        const SVG_HEIGHT = 100;
        for (let i = 0; i < titleContainerElementArray.length; i++) {
            // .cm-game-title-container
            var titleContainerElement = titleContainerElementArray[i];
            var titleContainerWidth = titleContainerElement.offsetWidth;

            // .cm-game-title-svg
            const titleSvgElement = titleContainerElement.querySelector(".cm-game-title-svg-chrome");

            // .cm-game-title-svg-div
            var titleSvgDivElement = titleContainerElement.querySelector(".cm-game-title-svg-div-chrome");
            var titleSvgDivHeight = titleSvgDivElement.offsetHeight;

            if (titleContainerWidth >= SVG_WIDTH) {
                const viewBoxString = titleSvgElement.getAttribute('viewBox').split(' ');

                const viewBox = [];
                for (let i = 0; i < viewBoxString.length; i++) {
                    viewBox.push(parseFloat(viewBoxString[i]))
                }
                const xMin = viewBox[0];
                const yMin = viewBox[1];
                const width = titleContainerWidth;
                const height = titleSvgDivHeight;
                const newViewBox = xMin + " " + yMin + " " + width + " " + height;

                // 設定#cm-game-title-svg中viewBox的屬性值
                titleSvgElement.setAttribute('viewBox', newViewBox);

                // 設定#cm-game-title-container的高度
                titleContainerElement.style.height = height + "px";
            }
            else { // 字體縮小效果
                // 依照比例計算出#cm-game-title-container的高度
                if (titleSvgDivHeight != 0) {
                    const titleContainerNewHeight = (titleContainerWidth / SVG_WIDTH) * titleSvgDivHeight;
                    titleContainerElement.style.height = titleContainerNewHeight + "px";
                }

                // 依照#cm-game-title-svg-div的高度判斷是否修改#cm-game-title-svg的viewBox
                if (SVG_HEIGHT < titleSvgDivHeight) {
                    // #cm-game-title-svg-div的高度超過SVG_HEIGHT
                    // 因此#cm-game-title-svg中viewBox的高度設定為#cm-game-title-svg-div的高度
                    // 否則超過的部分會被遮蔽
                    const newViewBox = "0 0 " + SVG_WIDTH + " " + titleSvgDivHeight;
                    titleSvgElement.setAttribute('viewBox', newViewBox);
                }
                else {
                    const newViewBox = "0 0 " + SVG_WIDTH + " " + SVG_HEIGHT;
                    titleSvgElement.setAttribute('viewBox', newViewBox);
                }
            }
        }
    }
}


/**
 * 首頁頁面遊戲介紹的title初始化
 */
function cm_game_svg_initial() {
    if (!isChrome()) {
        const titleContainerArray = document.querySelectorAll(".cm-game-title-container");
        if (titleContainerArray != null && titleContainerArray.length > 0) {
            for (let i = 0; i < titleContainerArray.length; i++) {
                if (titleContainerArray[i].querySelector(".cm-game-title-svg-div-chrome") != null) {
                    const titleSvgDivElement = titleContainerArray[i].querySelector(".cm-game-title-svg-div-chrome").cloneNode(true);
                    titleSvgDivElement.classList.remove("cm-game-title-svg-div-chrome");
                    titleSvgDivElement.classList.add("cm-game-title-div");
                    titleContainerArray[i].innerHTML = "";
                    titleContainerArray[i].appendChild(titleSvgDivElement);
                }
            }
        }


        const introContainerArray = document.querySelectorAll(".cm-game-intro-container");
        if (introContainerArray != null && introContainerArray.length > 0) {
            for (let i = 0; i < introContainerArray.length; i++) {
                if (introContainerArray[i].querySelector(".cm-game-intro-svg-div-chrome") != null) {
                    const introSvgDivElement = introContainerArray[i].querySelector(".cm-game-intro-svg-div-chrome").cloneNode(true);
                    introSvgDivElement.classList.remove("cm-game-intro-svg-div-chrome");
                    introSvgDivElement.classList.add("cm-game-intro-div");
                    introContainerArray[i].innerHTML = "";
                    introContainerArray[i].appendChild(introSvgDivElement);
                }
            }
        }
    }
    else {
        cm_title_container_dynamic_height();
    }

}




function isChrome() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.match(/chrome\/([\d.]+)/) && (userAgent.indexOf("windows") > -1)) {
        return true;
    }
    return false
}

export { cm_title_container_dynamic_height, cm_game_svg_initial }